module.exports = __webpack_public_path__ + "img/image-support-cf693291.png";